var exports = {
  "Q": "xfd349460--3c59f1--content",
};

module.exports = exports;
